module.exports = __webpack_public_path__ + "img/MaskGroup(3).8edd2f5f.png";